/**
 *  封装本地缓存(在main.js中注册)
 * Created by wfj on 2021-06-21.
 * @use:
        获取：_localStorage.get('key')
        删除：_localStorage.remove('key')
        普通设值：_localStorage.set('key', { a: 1 })
        带失效时间设值(第三个参数为失效时间{秒})：_localStorage.set('key', { a: 1 }, 100)
 */
var STORAGE_EXPIRE_MAP = 'STORAGE_EXPIRE_MAP'
var Storage = {
  /**
   * 获取缓存
   * @param key 键名
   * @returns {Object}
   */
  get: function (key) {
    const value = localStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      throw new Error(e.message)
    }
  },
  /**
   * 设置缓存
   * @param key 键名
   * @param object 键值
   * @param expire 有效时长（秒）
   */
  set: function (key, object, expire) {
    if (object !== null && object !== undefined) {
      let value = object
      if (typeof value !== 'string') {
        try {
          value = JSON.stringify(object)
        } catch (e) {
          value = null
        }
      }
      if (value !== null) {
        localStorage.setItem(key, value)
        if (expire && expire > 0) {
          var expireAt = new Date().getTime() + expire * 1000
          addExpire(key, expireAt)
        }
      }
    }
  },
  /**
   * 移除
   * @param key
   */
  remove: function (key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {}
  },
  /**
   * 清理
   */
  clear: function () {
    localStorage.clear()
  }
}

/**
 * 设置过期
 * @param key
 * @param expireAt
 */
function addExpire (key, expireAt) {
  var map = Storage.get(STORAGE_EXPIRE_MAP) || {}
  map[key] = expireAt
  Storage.set(STORAGE_EXPIRE_MAP, map)
}

/**
 * 清理过期
 */
function clearExpire () {
  var map = Storage.get(STORAGE_EXPIRE_MAP) || {}
  var now = new Date().getTime()
  for (var key in map) {
    if (map[key] * 1 < now) {
      Storage.remove(key)
      delete map[key]
    }
  }
  Storage.set(STORAGE_EXPIRE_MAP, map)
}

/**
 * 过期轮询
 */
setInterval(function () {
  clearExpire()
}, 60000)

export default Storage
